.selectWrapper {
  position: relative;
  display: inline-flex;
  width: 100%;
}

.select {
  appearance: none;
  -webkit-appearance: none;
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-body1-fontSize);
  line-height: var(--tuna-typography-body1-lineHeight);
  color: var(--tuna-palette-text-primary);
  padding: 8.5px 36px 8.5px 14px;
  /* Light rest sides; the bottom edge is the 3:1 identifying boundary (WCAG 1.4.11) */
  border: 1px solid var(--tuna-border-field);
  border-bottom-color: var(--tuna-content-secondary);
  border-radius: var(--tuna-shape-borderRadius);
  /* Not transparent: the native option list paints over what is behind the select (GH #2529) */
  background-color: var(--tuna-surface-input);
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
  outline: none;
  transition: border-color var(--tuna-transitions-duration-shorter) var(--tuna-transitions-easing-easeInOut);
}

.select:hover {
  border-color: var(--tuna-palette-text-primary);
}

.select:focus-visible {
  border-color: var(--tuna-palette-primary-main);
  border-width: 2px;
  padding: 7.5px 35px 7.5px 13px;
}

.error {
  border-color: var(--tuna-palette-error-main);
}

.select:disabled {
  color: var(--tuna-palette-text-disabled);
  border-color: var(--tuna-palette-action-disabledBackground);
  cursor: default;
}

.select:disabled ~ .arrow {
  opacity: 0.38;
}

.arrow {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid var(--tuna-palette-text-secondary);
  pointer-events: none;
  transition: border-color var(--tuna-transitions-duration-shorter) var(--tuna-transitions-easing-easeInOut);
}

.select:hover ~ .arrow {
  border-top-color: var(--tuna-palette-text-primary);
}

.select:focus-visible ~ .arrow {
  border-top-color: var(--tuna-palette-primary-main);
}

/* Touch: 44px rows (GH #2406, WCAG 2.5.5); font unchanged, desktop stays dense */
@media (pointer: coarse) {
  /* The native <select> that Select renders */
  .select {
    min-height: 44px;
  }
}

.formControl {
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  min-width: 0;
}

.inputLabel {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-palette-text-secondary);
  transform-origin: top left;
  pointer-events: none;
}

.formLabel {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-palette-text-secondary);
  font-family: var(--tuna-typography-fontFamily);
}

.helperText {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-palette-text-secondary);
  font-family: var(--tuna-typography-fontFamily);
  margin: 3px 14px 0;
}

.helperTextError {
  color: var(--tuna-palette-error-main);
}

.textField {
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  min-width: 0;
  flex: 1 1 auto;
}
